webpackJsonp([263791100135453],{

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(36);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = function (_ref) {
	  var to = _ref.to,
	      props = _objectWithoutProperties(_ref, ['to']);
	
	  var isExternalLink = false;
	  if (/^https?:\/\/.*/.test(to)) {
	    isExternalLink = true;
	  }
	
	  return isExternalLink ? Glamor.createElement('a', _extends({ href: to }, props)) : Glamor.createElement(_gatsbyLink2.default, _extends({ to: to }, props));
	};
	
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(50);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _link = __webpack_require__(11);
	
	var _link2 = _interopRequireDefault(_link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var repositories = [{
	  text: 'Hacker News app built with Gatsby.',
	  url: 'https://github.com/emmafallancy/hnpwa-gatsby'
	}, {
	  text: 'Chimerical, a dashboard like web app.',
	  url: 'https://github.com/emmafallancy/chimerical-partner-node'
	}, {
	  text: 'And more in my Github repositories.',
	  url: 'https://github.com/emmafallancy?tab=repositories'
	}];
	
	var contributions = [{
	  text: 'Gatsby',
	  url: 'https://github.com/gatsbyjs/gatsby/commits?author=emmafallancy'
	}, {
	  text: 'React website',
	  url: 'https://github.com/reactjs/reactjs.org/commits?author=emmafallancy'
	}, {
	  text: 'Next.js Starter Project',
	  url: 'https://github.com/iaincollins/nextjs-starter/commits?author=emmafallancy'
	}, {
	  text: 'Glamorous website',
	  url: 'https://github.com/kentcdodds/glamorous-website/commits?author=emmafallancy'
	}];
	
	var ProjectLink = function ProjectLink(_ref) {
	  var url = _ref.url,
	      text = _ref.text;
	  return Glamor.createElement(
	    'p',
	    {
	      css: {
	        fontSize: '1.8rem',
	        lineHeight: '1.45',
	        margin: '0 0 1.5rem'
	      }
	    },
	    Glamor.createElement(
	      _link2.default,
	      {
	        to: url,
	        css: {
	          color: '#000000',
	          fontSize: '1.8rem',
	          borderBottom: '2px dashed #25ced1',
	          textDecoration: 'none'
	        }
	      },
	      text
	    )
	  );
	};
	
	var About = function About() {
	  return Glamor.createElement(
	    'div',
	    {
	      css: {
	        margin: '0 auto 2rem',
	        maxWidth: '960px',
	        padding: '0 2rem'
	      }
	    },
	    Glamor.createElement(_reactHelmet2.default, {
	      title: '\uD83C\uDF89 About - Emmanuel Fallancy',
	      meta: [{
	        name: 'description',
	        content: 'Get to know who and what is Emmanuel into nowadays.'
	      }, {
	        name: 'keywords',
	        content: 'efallancy, Emmanuel Fallancy, emmanuel fallancy'
	      }]
	    }),
	    Glamor.createElement(
	      'header',
	      {
	        css: {
	          padding: '0 1rem',
	          textAlign: 'center',
	          margin: '0 auto',
	          maxWidth: '300px'
	        }
	      },
	      Glamor.createElement(
	        'h1',
	        {
	          css: {
	            position: 'relative',
	            padding: '1rem 0',
	            '&::before': {
	              content: '""',
	              backgroundColor: 'rgba(37, 206, 209, 0.65)',
	              position: 'absolute',
	              top: '0',
	              left: '0',
	              transform: 'skew(-20deg)',
	              width: '100%',
	              height: '100%',
	              zIndex: '-1'
	            }
	          }
	        },
	        'Hi there!'
	      )
	    ),
	    Glamor.createElement(
	      'main',
	      {
	        css: {
	          margin: '0 auto',
	          maxWidth: '480px'
	        }
	      },
	      Glamor.createElement(
	        'p',
	        {
	          css: {
	            fontSize: '1.8rem',
	            textAlign: 'center'
	          }
	        },
	        'I am ',
	        Glamor.createElement(
	          'b',
	          null,
	          'Emmanuel Fallancy'
	        ),
	        '. A web developer based in Sydney. Love learning, open source enthusiast, and enjoys having (strong) coffee.'
	      )
	    ),
	    Glamor.createElement(
	      'div',
	      {
	        css: {
	          display: 'flex',
	          width: '100%',
	          '@media (max-width: 767px)': {
	            flexWrap: 'wrap'
	          }
	        }
	      },
	      Glamor.createElement(
	        'div',
	        {
	          css: {
	            background: '#fffffc',
	            border: '1px solid #25ced1',
	            boxShadow: '0 5px 5px 0 rgba(0,0,0,0.50)',
	            borderRadius: '5px',
	            display: 'inline-block',
	            marginRight: '0.5rem',
	            padding: '2rem 1.5rem',
	            width: 'calc(100% / 2)',
	            '@media (max-width: 767px)': {
	              display: 'block',
	              width: '100%',
	              marginRight: '0',
	              marginBottom: '2rem'
	            }
	          }
	        },
	        Glamor.createElement(
	          'h3',
	          {
	            css: {
	              fontSize: '2.4rem',
	              margin: '0 0 2rem'
	            }
	          },
	          'Some of the few tech(s) that I use in my adventure as developer.'
	        ),
	        Glamor.createElement(
	          'p',
	          {
	            css: {
	              fontSize: '1.8rem',
	              lineHeight: '1.45',
	              margin: '0 0 1rem'
	            }
	          },
	          '\uD83C\uDFC1 Using NodeJS for most of my work while exploring Rust, Clojure and Go.'
	        ),
	        Glamor.createElement(
	          'p',
	          {
	            css: {
	              fontSize: '1.8rem',
	              lineHeight: '1.45',
	              margin: '0 0 1rem'
	            }
	          },
	          '\u269B\uFE0F Spend most of my time in React and juggling with Vue at the same time.'
	        ),
	        Glamor.createElement(
	          'p',
	          {
	            css: {
	              fontSize: '1.8rem',
	              lineHeight: '1.45',
	              margin: '0 0 1rem'
	            }
	          },
	          '\uD83C\uDFAF Oftenly with Gatsby and Next.js when it comes to framework.'
	        ),
	        Glamor.createElement(
	          'p',
	          {
	            css: {
	              fontSize: '1.8rem',
	              lineHeight: '1.45',
	              margin: '0 0 1rem'
	            }
	          },
	          '\uD83D\uDCE1 Into GraphQL and suprisingly convinced myself to build GraphQL server for managing sitemap.'
	        ),
	        Glamor.createElement(
	          'p',
	          {
	            css: {
	              fontSize: '1.8rem',
	              lineHeight: '1.45',
	              margin: '0 0 1rem'
	            }
	          },
	          '\uD83D\uDCCA Either PostgresQL or MongoDB but preferably, CMS like services wherever JAMStack is possible.'
	        ),
	        Glamor.createElement(
	          'p',
	          {
	            css: {
	              fontSize: '1.8rem',
	              lineHeight: '1.45',
	              margin: '0 0 1rem'
	            }
	          },
	          '\uD83D\uDCD0 Sketch as my weapon of choice for wireframing and prototyping.'
	        ),
	        Glamor.createElement(
	          'p',
	          {
	            css: {
	              fontSize: '1.8rem',
	              lineHeight: '1.45',
	              margin: '0 0 1rem'
	            }
	          },
	          '\uD83D\uDCBB Using Hyper as my terminal.'
	        )
	      ),
	      Glamor.createElement(
	        'div',
	        {
	          css: {
	            background: '#fffffc',
	            border: '1px solid #25ced1',
	            boxShadow: '0 5px 5px 0 rgba(0,0,0,0.50)',
	            borderRadius: '5px',
	            display: 'inline-block',
	            marginLeft: '0.5rem',
	            padding: '2rem 1.5rem',
	            width: 'calc(100% / 2)',
	            '@media (max-width: 767px)': {
	              display: 'block',
	              width: '100%',
	              marginLeft: '0'
	            }
	          }
	        },
	        Glamor.createElement(
	          'div',
	          {
	            css: {
	              margin: '0 0 4rem'
	            }
	          },
	          Glamor.createElement(
	            'h3',
	            {
	              css: {
	                fontSize: '2.4rem',
	                margin: '0 0 2rem'
	              }
	            },
	            'Things I made'
	          ),
	          repositories.map(function (_ref2, index) {
	            var text = _ref2.text,
	                url = _ref2.url;
	            return Glamor.createElement(ProjectLink, { text: text, url: url, key: index });
	          })
	        ),
	        Glamor.createElement(
	          'div',
	          {
	            css: {
	              margin: '0 0 4rem'
	            }
	          },
	          Glamor.createElement(
	            'h3',
	            {
	              css: {
	                fontSize: '2.4rem',
	                margin: '0 0 2rem'
	              }
	            },
	            'Projects I contributed to'
	          ),
	          contributions.map(function (_ref3, index) {
	            var text = _ref3.text,
	                url = _ref3.url;
	            return Glamor.createElement(ProjectLink, { text: text, url: url, key: index });
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.default = About;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-50b53570b48fad73095d.js